export default __webpack_public_path__ + "static/media/A22.fe28c392.png";